/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"CBean":"CBean_8U4lj","icon":"icon_XhzZX"};